import { FileBrowserGdt } from "components/FlyoutFiles/FlyoutFilesGDT";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";

export const ProjectTabFiles = () => {
  const projectKey = useDataTableContext((s) => s.project.key);
  // wraps in a div with height set so the file browser doesn't collapse
  // down to minimum height - especially important when no files in project
  return (
    <div style={{ display: "flex", minHeight: 300, height: "100%" }}>
      <FileBrowserGdt projectKey={projectKey} />
    </div>
  );
};
